import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import YourJourneyStartsHere from "./sections/YourJourneyStartsHere";
import AboutVisual from "./sections/AboutVisual";
import CoreIntelligenceTracks from "./sections/CoreIntelligenceTracks";
import WhyWorkWithUs from "./sections/WhyWorkWithUs";
import FaqAccordion from "./sections/FaqAccordion";
import Processo from "./sections/Processo";
import OurCases from "./sections/OurCases";
import TheMovement from "./sections/TheMovement";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <YourJourneyStartsHere />
      <AboutVisual />
      <CoreIntelligenceTracks />
      <FaqAccordion />
      <Processo />
      <WhyWorkWithUs />
      <OurCases />
      <TheMovement />
      <CallToAction />
      <Footer />
    </div>;
}